import { render, staticRenderFns } from "./DashboardTableAdherents.vue?vue&type=template&id=2c1244a8&"
import script from "./DashboardTableAdherents.vue?vue&type=script&lang=js&"
export * from "./DashboardTableAdherents.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTableAdherents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports